import { getConfig } from '../config'
import { get } from '../utils/api'

export const getMerchantSettingApi = async () => {
	return await new Promise((resolve, reject) => {
		get(`${getConfig().PLATFORM_API_URL}/user/merchantSetting`)
			.then(response => response.json())
			.then(data => resolve(data.data))
			.catch(error => reject(error))
	})
}

export const getCustomerServiceUrl = async () => {
	return await new Promise((resolve, reject) => {
		get(`${getConfig().PLATFORM_API_URL}/sysmaintenance/customerService`)
			.then(response => response.json())
			.then(data => resolve(data.data))
			.catch(error => reject(error))
	})
}